import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation, inject } from '@angular/core';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

import { ManageLockAssignmentsComponent } from 'src/shared/components/manage-lock-assignments/manage-lock-assignments.component';

import { SeamService } from 'src/shared/services/seam.service';

@Component({
  selector: 'smart-lock-chooser',
  templateUrl: './smart-lock-chooser.component.html',
  styleUrls: ['./smart-lock-chooser.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SmartLockChooserComponent implements OnInit {
  private rightSidePanelService = inject(RightSidePanelService);
  private navCtrl = inject(CustomNavController);
  private cdr = inject(ChangeDetectorRef);
  private storage = inject(TidyStorage);
  private seamService = inject(SeamService);
  windowService = inject(WindowService);

  loaded = false;
  hasIntegration = false;

  async ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Connect Locks');
    try {
      const integrations = await this.seamService.getExistingIntegration();
      this.hasIntegration = integrations.length > 0;
    } catch {
      this.hasIntegration = false;
    }
    if (!this.hasIntegration) {
      // Nothing to "update" yet — skip the chooser and head straight into
      // the connect step. This mirrors the Access page's direct entry: the
      // user never sees the chooser, so the title stays "Connect Locks".
      const params = { startOnConnect: true };
      if (this.windowService.isDesktopRes) {
        await this.storage.save('dialog-params', params);
        await this.rightSidePanelService.navigateTo(
          'smart-locks/manage-assignments',
          params,
          ManageLockAssignmentsComponent
        );
      } else {
        await this.storage.save('dialog-params', params);
        this.navCtrl.navigateForward('smart-locks/manage-assignments', params);
      }
      return;
    }
    this.loaded = true;
    this.cdr.markForCheck();
  }

  goToManageAssignments = async () => {
    const params = { flowMode: 'updateExisting' };
    if (this.windowService.isDesktopRes) {
      await this.storage.save('dialog-params', params);
      await this.rightSidePanelService.navigateTo(
        'smart-locks/manage-assignments',
        params,
        ManageLockAssignmentsComponent
      );
    } else {
      await this.storage.save('dialog-params', params);
      this.navCtrl.navigateForward('smart-locks/manage-assignments', params);
    }
  };

  goToConnectSeam = async () => {
    const params = { startOnConnect: true, flowMode: 'addEditSeam' };
    if (this.windowService.isDesktopRes) {
      await this.storage.save('dialog-params', params);
      await this.rightSidePanelService.navigateTo(
        'smart-locks/manage-assignments',
        params,
        ManageLockAssignmentsComponent
      );
    } else {
      await this.storage.save('dialog-params', params);
      this.navCtrl.navigateForward('smart-locks/manage-assignments', params);
    }
  };
}
